import React from 'react';
import { isMobile } from '../../utils/global';

export const BluePredicatenIcon = React.memo(() =>
  isMobile() ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="53"
      viewBox="0 0 41 53"
      fill="none"
    >
      <g clipPath="url(#clip0_1_1941)">
        <path
          d="M21.5264 24.7787H19.8179L10.0041 14.1171C8.80944 12.8325 8.14148 11.1369 8.14148 9.37712V0H33.1899V9.37712C33.1899 11.1369 32.522 12.8325 31.3402 14.1299L21.5264 24.7787Z"
          fill="#004DF5"
        />
        <path
          d="M20.6657 52.9229C31.8534 52.9229 40.9229 43.8535 40.9229 32.6658C40.9229 21.4781 31.8534 12.4086 20.6657 12.4086C9.478 12.4086 0.408569 21.4781 0.408569 32.6658C0.408569 43.8535 9.478 52.9229 20.6657 52.9229Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6658 12.4857C9.52061 12.4857 0.485687 21.5206 0.485687 32.6658C0.485687 43.8109 9.52061 52.8459 20.6658 52.8459C31.8109 52.8459 40.8458 43.8109 40.8458 32.6658C40.8458 21.5206 31.8109 12.4857 20.6658 12.4857ZM0.331543 32.6658C0.331543 21.4355 9.43548 12.3316 20.6658 12.3316C31.896 12.3316 41 21.4355 41 32.6658C41 43.8961 31.896 53 20.6658 53C9.43548 53 0.331543 43.8961 0.331543 32.6658Z"
          fill="#AAAAAA"
        />
        <path
          d="M20.6658 14.6566C10.6978 14.6566 2.60522 22.7363 2.60522 32.7172C2.60522 42.698 10.685 50.7778 20.6658 50.7778C30.6467 50.7778 38.7264 42.698 38.7264 32.7172C38.7264 22.7363 30.6467 14.6566 20.6658 14.6566Z"
          fill="#004DF5"
        />
        <path
          d="M20.6658 17.2899C12.1493 17.2899 5.25134 24.1878 5.25134 32.7043C5.25134 41.2208 12.1493 48.1188 20.6658 48.1188C29.1823 48.1188 36.0802 41.2208 36.0802 32.7043C36.0802 24.1878 29.1823 17.2899 20.6658 17.2899Z"
          fill="white"
        />
        <path
          d="M7.30652 28.2341H8.93788C9.92697 28.2341 10.4408 28.6452 10.4408 29.4159C10.4408 29.7884 10.2866 30.0582 10.0169 30.2252C10.338 30.405 10.5179 30.7004 10.5179 31.1115C10.5179 31.9721 9.92697 32.3575 8.93788 32.3575H7.30652V28.2341ZM8.26992 29.0948V29.827H8.98926C9.33609 29.827 9.46454 29.6728 9.46454 29.4544C9.46454 29.2232 9.32324 29.0948 8.97642 29.0948H8.26992ZM8.26992 30.6876V31.484H8.96357C9.34893 31.484 9.51592 31.3427 9.51592 31.073C9.51592 30.8032 9.37462 30.6748 8.95073 30.6748H8.26992V30.6876Z"
          fill="#004DF5"
        />
        <path
          d="M11.0446 28.2341H13.8962V29.1462H12.0336V29.827H13.8962V30.739H12.0336V31.4455H13.8962V32.3575H11.0446V28.2341Z"
          fill="#004DF5"
        />
        <path
          d="M14.2302 31.5868L15.078 30.906C15.3221 31.2785 15.6432 31.484 16.1056 31.484C16.4396 31.484 16.6195 31.3299 16.6195 31.0986C16.6195 30.816 16.3497 30.7647 15.7717 30.6234C15.1679 30.4821 14.4743 30.2637 14.4743 29.4159C14.4743 28.6966 15.1037 28.1442 15.9772 28.1442C16.7351 28.1442 17.1847 28.4011 17.6214 28.8764L16.825 29.493C16.6323 29.1847 16.3626 29.0049 15.9515 29.0049C15.6175 29.0049 15.4634 29.1847 15.4634 29.3774C15.4634 29.6343 15.7974 29.6857 16.2983 29.8013C16.9149 29.9426 17.6471 30.1609 17.6471 31.0473C17.6471 31.8308 16.992 32.396 16.08 32.396C15.1551 32.4089 14.6156 32.062 14.2302 31.5868Z"
          fill="#004DF5"
        />
        <path
          d="M19.0215 29.1462H17.9039V28.2341H21.0896V29.1462H19.9849V32.3575H19.0215V29.1462Z"
          fill="#004DF5"
        />
        <path
          d="M21.642 28.2341H24.4936V29.1462H22.6311V29.827H24.4936V30.739H22.6311V31.4455H24.4936V32.3575H21.642V28.2341Z"
          fill="#004DF5"
        />
        <path
          d="M26.3306 30.739V28.2341H27.3325V30.739C27.3325 31.2014 27.5894 31.4583 27.9876 31.4583C28.3858 31.4583 28.6556 31.2014 28.6556 30.739V28.2341H29.6575V30.739C29.6575 31.8051 29.0024 32.4217 27.9876 32.4217C26.9728 32.4217 26.3306 31.8051 26.3306 30.739Z"
          fill="#004DF5"
        />
        <path
          d="M30.2869 28.2341H31.276V32.3575H30.2869V28.2341Z"
          fill="#004DF5"
        />
        <path
          d="M32.9587 29.1462H31.8412V28.2341H35.0268V29.1462H33.9221V32.3575H32.9587V29.1462Z"
          fill="#004DF5"
        />
        <path
          d="M9.77295 33.3723H11.2373C12.5219 33.3723 13.3825 34.2714 13.3825 35.4404C13.3825 36.6093 12.4833 37.5085 11.2502 37.5085H9.77295V33.3723ZM10.762 34.2843V36.5708H11.2116C11.931 36.5708 12.3934 36.0698 12.3934 35.4275C12.3934 34.7853 11.9695 34.2843 11.1988 34.2843H10.762Z"
          fill="#004DF5"
        />
        <path
          d="M13.9092 33.3723H16.7609V34.2843H14.8983V34.9651H16.7609V35.8771H14.8983V36.5836H16.7609V37.4956H13.9092V33.3723Z"
          fill="#004DF5"
        />
        <path
          d="M19.6639 34.2843H18.5464V33.3723H21.732V34.2843H20.6273V37.4956H19.6639V34.2843Z"
          fill="#004DF5"
        />
        <path
          d="M22.2843 33.3723H25.1232V34.2843H23.2606V34.9651H25.1232V35.8771H23.2606V36.5836H25.1232V37.4956H22.2715V33.3723H22.2843Z"
          fill="#004DF5"
        />
        <path
          d="M25.4572 36.7249L26.3049 36.0441C26.549 36.4166 26.8701 36.6221 27.3326 36.6221C27.6666 36.6221 27.8464 36.468 27.8464 36.2368C27.8464 35.9542 27.5766 35.9028 26.9986 35.7615C26.3949 35.6202 25.7012 35.4018 25.7012 34.554C25.7012 33.8347 26.3306 33.2823 27.2041 33.2823C27.962 33.2823 28.4116 33.5393 28.8483 34.0145L28.0519 34.6311C27.8592 34.3228 27.5895 34.143 27.1784 34.143C26.8445 34.143 26.6903 34.3228 26.6903 34.5155C26.6903 34.7724 27.0243 34.8238 27.5253 34.9394C28.1418 35.0807 28.874 35.2991 28.874 36.1854C28.874 36.969 28.2189 37.5342 27.3069 37.5342C26.382 37.547 25.8554 37.2002 25.4572 36.7249Z"
          fill="#004DF5"
        />
        <path
          d="M30.2613 34.2843H29.1438V33.3723H32.3295V34.2843H31.2247V37.4956H30.2613V34.2843Z"
          fill="#004DF5"
        />
        <path
          d="M20.6658 4.75279C20.6273 4.75279 20.5887 4.73995 20.563 4.71426L19.5611 3.72516C19.4969 3.66094 19.484 3.57102 19.5097 3.49395C19.5483 3.41688 19.6125 3.36549 19.7024 3.36549H21.6292C21.7191 3.36549 21.7834 3.41688 21.8219 3.49395C21.8604 3.57102 21.8347 3.66094 21.7705 3.72516L20.7686 4.71426C20.7429 4.73995 20.7043 4.75279 20.6658 4.75279Z"
          fill="white"
        />
        <path
          d="M18.1737 8.85046C18.3792 8.85046 18.5334 8.68347 18.5334 8.47794C18.5334 8.27241 18.3792 8.10542 18.1737 8.10542C17.9682 8.10542 17.814 8.27241 17.814 8.47794C17.814 8.68347 17.9682 8.85046 18.1737 8.85046ZM17.8269 9.0046V9.19728H17.4415V7.25763H17.8269V7.96412C17.9168 7.83567 18.071 7.74575 18.2508 7.74575C18.5976 7.74575 18.9187 8.02835 18.9187 8.49079C18.9187 8.95322 18.5976 9.23582 18.2508 9.23582C18.071 9.22297 17.9168 9.1459 17.8269 9.0046Z"
          fill="white"
        />
        <path
          d="M20.229 8.49079C20.229 8.28526 20.0749 8.11827 19.8693 8.11827C19.6638 8.11827 19.5097 8.28526 19.5097 8.49079C19.5097 8.69632 19.6638 8.86331 19.8693 8.86331C20.0749 8.85046 20.229 8.68347 20.229 8.49079ZM19.1115 8.49079C19.1115 8.07974 19.4326 7.74576 19.8693 7.74576C20.3061 7.74576 20.6272 8.07974 20.6272 8.49079C20.6272 8.90184 20.3061 9.23582 19.8693 9.23582C19.4326 9.22298 19.1115 8.889 19.1115 8.49079Z"
          fill="white"
        />
        <path
          d="M20.8456 7.77145H21.2438V7.95128C21.3337 7.82283 21.475 7.74576 21.642 7.74576C21.9631 7.74576 22.1815 7.96413 22.1815 8.3238V9.19729H21.7833V8.38803C21.7833 8.19535 21.6934 8.09258 21.5264 8.09258C21.3722 8.09258 21.2566 8.20819 21.2566 8.41372V9.19729H20.8584L20.8456 7.77145Z"
          fill="white"
        />
        <path
          d="M23.5303 8.49078C23.5303 8.28526 23.3762 8.11827 23.1706 8.11827C22.9651 8.11827 22.811 8.28526 22.811 8.49078C22.811 8.69631 22.9779 8.8633 23.1706 8.8633C23.3633 8.85046 23.5303 8.68347 23.5303 8.49078ZM22.3999 8.49078C22.3999 8.0412 22.721 7.74575 23.0807 7.74575C23.2605 7.74575 23.4147 7.82283 23.5046 7.95128V7.25763H23.89V9.19728H23.5046V9.0046C23.4147 9.1459 23.2605 9.22297 23.0807 9.22297C22.7339 9.22297 22.3999 8.94037 22.3999 8.49078Z"
          fill="white"
        />
        <path
          d="M14.6926 6.12725C14.6926 5.92172 14.5385 5.75473 14.333 5.75473C14.1274 5.75473 13.9733 5.92172 13.9733 6.12725C13.9733 6.33277 14.1274 6.49976 14.333 6.49976C14.5256 6.49976 14.6926 6.33277 14.6926 6.12725ZM13.5751 6.12725C13.5751 5.7162 13.8962 5.38222 14.333 5.38222C14.7697 5.38222 15.0908 5.7162 15.0908 6.12725C15.0908 6.5383 14.7697 6.87228 14.333 6.87228C13.8962 6.87228 13.5751 6.5383 13.5751 6.12725Z"
          fill="white"
        />
        <path
          d="M15.3092 5.42074H15.7074V5.60058C15.7973 5.47212 15.9386 5.39505 16.1056 5.39505C16.4268 5.39505 16.6451 5.61342 16.6451 5.97309V6.84658H16.2341V6.03732C16.2341 5.84464 16.1442 5.74188 15.9772 5.74188C15.823 5.74188 15.7074 5.85748 15.7074 6.06301V6.84658H15.3092V5.42074Z"
          fill="white"
        />
        <path
          d="M16.8121 6.49976L17.1975 6.37131C17.2489 6.48692 17.3645 6.55115 17.5058 6.55115C17.6342 6.55115 17.7113 6.48692 17.7113 6.40985C17.7113 6.31993 17.57 6.29424 17.3902 6.2557C17.1461 6.20432 16.8764 6.12725 16.8764 5.83181C16.8764 5.58774 17.1204 5.38222 17.4672 5.38222C17.7755 5.38222 17.9554 5.49783 18.0967 5.70335L17.7242 5.83181C17.6728 5.74189 17.5829 5.69051 17.4672 5.69051C17.3388 5.69051 17.2746 5.74189 17.2746 5.80611C17.2746 5.88319 17.3902 5.90888 17.5957 5.94741C17.8269 5.99879 18.1224 6.07587 18.1224 6.38416C18.1224 6.61537 17.9168 6.85944 17.4929 6.85944C17.1333 6.87228 16.9277 6.74383 16.8121 6.49976Z"
          fill="white"
        />
        <path
          d="M18.3022 6.28139V5.42075H18.7133V6.23C18.7133 6.40984 18.8032 6.52545 18.9702 6.52545C19.1244 6.52545 19.24 6.40984 19.24 6.20431V5.42075H19.6382V6.84658H19.24V6.66675C19.15 6.7952 19.0087 6.87227 18.8418 6.87227C18.5078 6.87227 18.3022 6.6539 18.3022 6.28139Z"
          fill="white"
        />
        <path
          d="M19.9079 5.42074H20.3061V5.58773C20.396 5.45928 20.5245 5.39505 20.6915 5.39505C20.897 5.39505 21.0383 5.48497 21.1154 5.62627C21.2053 5.48497 21.3594 5.39505 21.5521 5.39505C21.8989 5.39505 22.0788 5.61342 22.0788 5.96025V6.84658H21.6677V6.02447C21.6677 5.84464 21.5906 5.74188 21.4236 5.74188C21.2823 5.74188 21.1796 5.84464 21.1796 6.05016V6.84658H20.7685V6.02447C20.7685 5.84464 20.6915 5.74188 20.5373 5.74188C20.3832 5.74188 20.2804 5.84464 20.2804 6.06301V6.84658H19.8822V5.42074H19.9079Z"
          fill="white"
        />
        <path
          d="M22.6953 5.96025H23.3889C23.3376 5.8061 23.2091 5.71618 23.0421 5.71618C22.888 5.72903 22.7595 5.81895 22.6953 5.96025ZM22.3099 6.14008C22.3099 5.72903 22.6311 5.39505 23.055 5.39505C23.4789 5.39505 23.7872 5.70334 23.7872 6.12724V6.26854H22.6825C22.7338 6.43553 22.8623 6.53829 23.055 6.53829C23.2091 6.53829 23.3119 6.47406 23.3889 6.35845L23.7101 6.55113C23.5688 6.75666 23.3633 6.87227 23.055 6.87227C22.5925 6.87227 22.3099 6.55113 22.3099 6.14008Z"
          fill="white"
        />
        <path
          d="M24.0056 5.42074H24.4038V5.60058C24.4937 5.47212 24.635 5.39505 24.802 5.39505C25.1232 5.39505 25.3415 5.61342 25.3415 5.97309V6.84658H24.9305V6.03732C24.9305 5.84464 24.8406 5.74188 24.6736 5.74188C24.5194 5.74188 24.4038 5.85748 24.4038 6.06301V6.84658H24.0056V5.42074Z"
          fill="white"
        />
        <path
          d="M25.4956 5.42075H25.7525V5.17668L26.1379 4.95831V5.43359H26.4975V5.78042H26.1379V6.31992C26.1379 6.47407 26.2021 6.5126 26.2792 6.5126C26.3306 6.5126 26.3691 6.49976 26.4076 6.46122L26.5875 6.76951C26.4847 6.84658 26.3691 6.88512 26.2278 6.88512C25.9195 6.88512 25.7525 6.74382 25.7525 6.34561V5.79326H25.4956V5.42075Z"
          fill="white"
        />
        <path
          d="M27.0113 5.96025H27.705C27.6536 5.8061 27.5252 5.71618 27.3582 5.71618C27.204 5.72903 27.0756 5.81895 27.0113 5.96025ZM26.626 6.14008C26.626 5.72903 26.9471 5.39505 27.371 5.39505C27.7949 5.39505 28.1032 5.70334 28.1032 6.12724V6.26854H26.9985C27.0499 6.43553 27.1783 6.53829 27.371 6.53829C27.5252 6.53829 27.6279 6.47406 27.705 6.35845L28.0261 6.55113C27.8848 6.75666 27.6793 6.87227 27.371 6.87227C26.9214 6.87227 26.626 6.55113 26.626 6.14008Z"
          fill="white"
        />
        <path
          d="M28.3217 5.42074H28.7199V5.60058C28.8098 5.47212 28.9511 5.39505 29.1181 5.39505C29.4392 5.39505 29.6576 5.61342 29.6576 5.97309V6.84658H29.2465V6.03732C29.2465 5.84464 29.1566 5.74188 28.9896 5.74188C28.8355 5.74188 28.7199 5.85748 28.7199 6.06301V6.84658H28.3217V5.42074Z"
          fill="white"
        />
        <path
          d="M12.5988 6.84658C12.085 6.84658 11.674 6.43553 11.674 5.92171C11.674 5.4079 12.1235 5.00969 12.586 5.00969C12.8429 5.00969 13.0612 5.09961 13.2282 5.2666L12.9328 5.56204C12.83 5.45928 12.7144 5.42074 12.5988 5.42074C12.3034 5.42074 12.1107 5.65196 12.1107 5.92171C12.1107 6.21715 12.3162 6.43553 12.5988 6.43553C12.7915 6.43553 12.9713 6.31992 13.0356 6.12724H13.4723C13.3952 6.55113 13.0099 6.84658 12.5988 6.84658Z"
          fill="white"
        />
        <path
          d="M20.6658 25.0228C20.5631 25.0228 20.4475 24.9842 20.3704 24.9072L17.4802 22.0683C17.3003 21.8885 17.249 21.6316 17.3389 21.4132C17.4288 21.182 17.6472 21.0407 17.8912 21.0407H23.4276C23.6716 21.0407 23.89 21.182 23.9799 21.4132C24.0698 21.6444 24.0185 21.9014 23.8386 22.0683L20.9484 24.9072C20.8842 24.9842 20.7814 25.0228 20.6658 25.0228Z"
          fill="#004DF5"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_1941">
          <rect
            width="40.6684"
            height="53"
            fill="white"
            transform="translate(0.331543)"
          />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="64"
      viewBox="0 0 50 64"
      fill="none"
    >
      <g clipPath="url(#clip0_14_3882)">
        <path
          d="M25.8544 29.9215H23.7914L11.9407 17.047C10.4981 15.4959 9.69153 13.4484 9.69153 11.3233V0H39.9387V11.3233C39.9387 13.4484 39.1321 15.4959 37.7051 17.0625L25.8544 29.9215Z"
          fill="#004DF5"
        />
        <path
          d="M24.8152 63.9069C38.3249 63.9069 49.2766 52.9552 49.2766 39.4455C49.2766 25.9358 38.3249 14.984 24.8152 14.984C11.3055 14.984 0.353699 25.9358 0.353699 39.4455C0.353699 52.9552 11.3055 63.9069 24.8152 63.9069Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.8152 15.0771C11.3569 15.0771 0.446757 25.9872 0.446757 39.4455C0.446757 52.9038 11.3569 63.8139 24.8152 63.8139C38.2734 63.8139 49.1835 52.9038 49.1835 39.4455C49.1835 25.9872 38.2734 15.0771 24.8152 15.0771ZM0.26062 39.4455C0.26062 25.8844 11.2541 14.8909 24.8152 14.8909C38.3762 14.8909 49.3697 25.8844 49.3697 39.4455C49.3697 53.0066 38.3762 64 24.8152 64C11.2541 64 0.26062 53.0066 0.26062 39.4455Z"
          fill="#AAAAAA"
        />
        <path
          d="M24.8152 17.6985C12.7783 17.6985 3.00616 27.4552 3.00616 39.5075C3.00616 51.5599 12.7628 61.3165 24.8152 61.3165C36.8675 61.3165 46.6242 51.5599 46.6242 39.5075C46.6242 27.4552 36.8675 17.6985 24.8152 17.6985Z"
          fill="#004DF5"
        />
        <path
          d="M24.8151 20.8783C14.5311 20.8783 6.20148 29.208 6.20148 39.492C6.20148 49.7761 14.5311 58.1057 24.8151 58.1057C35.0992 58.1057 43.4288 49.7761 43.4288 39.492C43.4288 29.208 35.0992 20.8783 24.8151 20.8783Z"
          fill="white"
        />
        <path
          d="M8.68329 34.094H10.6532C11.8476 34.094 12.4681 34.5904 12.4681 35.5211C12.4681 35.9709 12.2819 36.2967 11.9562 36.4983C12.344 36.7155 12.5611 37.0722 12.5611 37.5686C12.5611 38.6079 11.8476 39.0732 10.6532 39.0732H8.68329V34.094ZM9.84664 35.1333V36.0175H10.7153C11.1341 36.0175 11.2892 35.8313 11.2892 35.5676C11.2892 35.2884 11.1186 35.1333 10.6998 35.1333H9.84664ZM9.84664 37.0567V38.0184H10.6843C11.1496 38.0184 11.3512 37.8478 11.3512 37.5221C11.3512 37.1963 11.1806 37.0412 10.6687 37.0412H9.84664V37.0567Z"
          fill="#004DF5"
        />
        <path
          d="M13.1971 34.094H16.6406V35.1953H14.3915V36.0175H16.6406V37.1188H14.3915V37.9719H16.6406V39.0732H13.1971V34.094Z"
          fill="#004DF5"
        />
        <path
          d="M17.0439 38.1425L18.0677 37.3204C18.3624 37.7702 18.7502 38.0184 19.3086 38.0184C19.7119 38.0184 19.9291 37.8323 19.9291 37.5531C19.9291 37.2118 19.6033 37.1498 18.9053 36.9792C18.1763 36.8085 17.3387 36.5448 17.3387 35.5211C17.3387 34.6524 18.0987 33.9855 19.1535 33.9855C20.0687 33.9855 20.6116 34.2957 21.139 34.8696L20.1772 35.6142C19.9446 35.2419 19.6188 35.0247 19.1225 35.0247C18.7192 35.0247 18.533 35.2419 18.533 35.4746C18.533 35.7848 18.9363 35.8468 19.5413 35.9864C20.2858 36.1571 21.17 36.4207 21.17 37.491C21.17 38.4372 20.3789 39.1197 19.2776 39.1197C18.1608 39.1352 17.5093 38.7164 17.0439 38.1425Z"
          fill="#004DF5"
        />
        <path
          d="M22.8297 35.1953H21.4802V34.094H25.327V35.1953H23.993V39.0732H22.8297V35.1953Z"
          fill="#004DF5"
        />
        <path
          d="M25.994 34.094H29.4375V35.1953H27.1884V36.0175H29.4375V37.1188H27.1884V37.9719H29.4375V39.0732H25.994V34.094Z"
          fill="#004DF5"
        />
        <path
          d="M31.6556 37.1188V34.094H32.8655V37.1188C32.8655 37.6772 33.1758 37.9874 33.6566 37.9874C34.1375 37.9874 34.4632 37.6772 34.4632 37.1188V34.094H35.6731V37.1188C35.6731 38.4062 34.882 39.1508 33.6566 39.1508C32.4312 39.1508 31.6556 38.4062 31.6556 37.1188Z"
          fill="#004DF5"
        />
        <path
          d="M36.4332 34.094H37.6275V39.0732H36.4332V34.094Z"
          fill="#004DF5"
        />
        <path
          d="M39.6595 35.1953H38.3101V34.094H42.1569V35.1953H40.8229V39.0732H39.6595V35.1953Z"
          fill="#004DF5"
        />
        <path
          d="M11.6615 40.2986H13.4298C14.9809 40.2986 16.0202 41.3844 16.0202 42.7959C16.0202 44.2075 14.9344 45.2933 13.4453 45.2933H11.6615V40.2986ZM12.8559 41.3999V44.1609H13.3988C14.2674 44.1609 14.8258 43.556 14.8258 42.7804C14.8258 42.0048 14.3139 41.3999 13.3833 41.3999H12.8559Z"
          fill="#004DF5"
        />
        <path
          d="M16.6562 40.2986H20.0997V41.3999H17.8506V42.222H20.0997V43.3233H17.8506V44.1764H20.0997V45.2777H16.6562V40.2986Z"
          fill="#004DF5"
        />
        <path
          d="M23.6053 41.3999H22.2558V40.2986H26.1026V41.3999H24.7686V45.2777H23.6053V41.3999Z"
          fill="#004DF5"
        />
        <path
          d="M26.7696 40.2986H30.1976V41.3999H27.9485V42.222H30.1976V43.3233H27.9485V44.1764H30.1976V45.2777H26.7541V40.2986H26.7696Z"
          fill="#004DF5"
        />
        <path
          d="M30.6009 44.3471L31.6246 43.525C31.9194 43.9748 32.3071 44.223 32.8656 44.223C33.2688 44.223 33.486 44.0368 33.486 43.7576C33.486 43.4164 33.1603 43.3543 32.4623 43.1837C31.7332 43.0131 30.8956 42.7494 30.8956 41.7256C30.8956 40.857 31.6557 40.19 32.7104 40.19C33.6256 40.19 34.1685 40.5002 34.6959 41.0742L33.7342 41.8187C33.5015 41.4464 33.1758 41.2293 32.6794 41.2293C32.2761 41.2293 32.09 41.4464 32.09 41.6791C32.09 41.9893 32.4933 42.0514 33.0982 42.191C33.8428 42.3616 34.7269 42.6253 34.7269 43.6956C34.7269 44.6418 33.9358 45.3243 32.8345 45.3243C31.7177 45.3398 31.0817 44.921 30.6009 44.3471Z"
          fill="#004DF5"
        />
        <path
          d="M36.4022 41.3999H35.0527V40.2986H38.8995V41.3999H37.5655V45.2777H36.4022V41.3999Z"
          fill="#004DF5"
        />
        <path
          d="M24.8152 5.73922C24.7686 5.73922 24.7221 5.72371 24.6911 5.69268L23.4812 4.49831C23.4036 4.42075 23.3881 4.31217 23.4192 4.2191C23.4657 4.12603 23.5432 4.06399 23.6518 4.06399H25.9785C26.0871 4.06399 26.1647 4.12603 26.2112 4.2191C26.2577 4.31217 26.2267 4.42075 26.1492 4.49831L24.9393 5.69268C24.9082 5.72371 24.8617 5.73922 24.8152 5.73922Z"
          fill="white"
        />
        <path
          d="M21.806 10.6873C22.0541 10.6873 22.2403 10.4857 22.2403 10.2375C22.2403 9.98933 22.0541 9.78768 21.806 9.78768C21.5578 9.78768 21.3716 9.98933 21.3716 10.2375C21.3716 10.4857 21.5578 10.6873 21.806 10.6873ZM21.3872 10.8735V11.1062H20.9218V8.76393H21.3872V9.61706C21.4957 9.46194 21.6819 9.35336 21.899 9.35336C22.3178 9.35336 22.7056 9.69461 22.7056 10.253C22.7056 10.8114 22.3178 11.1527 21.899 11.1527C21.6819 11.1372 21.4957 11.0441 21.3872 10.8735Z"
          fill="white"
        />
        <path
          d="M24.2878 10.253C24.2878 10.0048 24.1016 9.8032 23.8535 9.8032C23.6053 9.8032 23.4191 10.0048 23.4191 10.253C23.4191 10.5012 23.6053 10.7029 23.8535 10.7029C24.1016 10.6874 24.2878 10.4857 24.2878 10.253ZM22.9383 10.253C22.9383 9.75667 23.3261 9.35337 23.8535 9.35337C24.3809 9.35337 24.7686 9.75667 24.7686 10.253C24.7686 10.7494 24.3809 11.1527 23.8535 11.1527C23.3261 11.1372 22.9383 10.7339 22.9383 10.253Z"
          fill="white"
        />
        <path
          d="M25.0323 9.38439H25.5131V9.60155C25.6217 9.44644 25.7923 9.35337 25.994 9.35337C26.3818 9.35337 26.6455 9.61706 26.6455 10.0514V11.1062H26.1646V10.1289C26.1646 9.89627 26.056 9.77218 25.8544 9.77218C25.6683 9.77218 25.5287 9.91178 25.5287 10.16V11.1062H25.0478L25.0323 9.38439Z"
          fill="white"
        />
        <path
          d="M28.2742 10.253C28.2742 10.0048 28.088 9.80319 27.8399 9.80319C27.5917 9.80319 27.4055 10.0048 27.4055 10.253C27.4055 10.5012 27.6072 10.7029 27.8399 10.7029C28.0725 10.6873 28.2742 10.4857 28.2742 10.253ZM26.9092 10.253C26.9092 9.71013 27.297 9.35336 27.7313 9.35336C27.9484 9.35336 28.1346 9.44643 28.2432 9.60155V8.76393H28.7085V11.1062H28.2432V10.8735C28.1346 11.0441 27.9484 11.1372 27.7313 11.1372C27.3125 11.1372 26.9092 10.7959 26.9092 10.253Z"
          fill="white"
        />
        <path
          d="M17.6024 7.39894C17.6024 7.15075 17.4162 6.94911 17.168 6.94911C16.9199 6.94911 16.7337 7.15075 16.7337 7.39894C16.7337 7.64712 16.9199 7.84877 17.168 7.84877C17.4007 7.84877 17.6024 7.64712 17.6024 7.39894ZM16.2529 7.39894C16.2529 6.90257 16.6407 6.49928 17.168 6.49928C17.6954 6.49928 18.0832 6.90257 18.0832 7.39894C18.0832 7.8953 17.6954 8.2986 17.168 8.2986C16.6407 8.2986 16.2529 7.8953 16.2529 7.39894Z"
          fill="white"
        />
        <path
          d="M18.3469 6.54581H18.8278V6.76297C18.9364 6.60785 19.107 6.51479 19.3086 6.51479C19.6964 6.51479 19.9601 6.77848 19.9601 7.2128V8.26757H19.4637V7.29036C19.4637 7.05768 19.3552 6.93359 19.1535 6.93359C18.9674 6.93359 18.8278 7.0732 18.8278 7.32138V8.26757H18.3469V6.54581Z"
          fill="white"
        />
        <path
          d="M20.1617 7.84877L20.6271 7.69365C20.6891 7.83325 20.8287 7.91081 20.9994 7.91081C21.1545 7.91081 21.2475 7.83326 21.2475 7.74019C21.2475 7.63161 21.0769 7.60058 20.8598 7.55405C20.565 7.492 20.2393 7.39894 20.2393 7.04217C20.2393 6.74746 20.534 6.49928 20.9528 6.49928C21.3251 6.49928 21.5423 6.63888 21.7129 6.88706L21.2631 7.04217C21.201 6.93359 21.0924 6.87155 20.9528 6.87155C20.7977 6.87155 20.7202 6.93359 20.7202 7.01115C20.7202 7.10422 20.8598 7.13524 21.1079 7.18178C21.3871 7.24382 21.7439 7.33689 21.7439 7.70916C21.7439 7.98837 21.4957 8.28309 20.9838 8.28309C20.5495 8.2986 20.3013 8.14348 20.1617 7.84877Z"
          fill="white"
        />
        <path
          d="M21.9611 7.58507V6.54581H22.4574V7.52302C22.4574 7.74018 22.566 7.87979 22.7677 7.87979C22.9538 7.87979 23.0934 7.74018 23.0934 7.492V6.54581H23.5742V8.26757H23.0934V8.05041C22.9848 8.20553 22.8142 8.29859 22.6125 8.29859C22.2092 8.29859 21.9611 8.0349 21.9611 7.58507Z"
          fill="white"
        />
        <path
          d="M23.9 6.54581H24.3808V6.74746C24.4894 6.59234 24.6445 6.51479 24.8462 6.51479C25.0944 6.51479 25.265 6.62337 25.3581 6.79399C25.4666 6.62337 25.6528 6.51479 25.8854 6.51479C26.3042 6.51479 26.5214 6.77848 26.5214 7.19729V8.26757H26.025V7.27484C26.025 7.05768 25.932 6.93359 25.7303 6.93359C25.5597 6.93359 25.4356 7.05768 25.4356 7.30587V8.26757H24.9392V7.27484C24.9392 7.05768 24.8462 6.93359 24.66 6.93359C24.4739 6.93359 24.3498 7.05768 24.3498 7.32138V8.26757H23.869V6.54581H23.9Z"
          fill="white"
        />
        <path
          d="M27.2659 7.19729H28.1036C28.0415 7.01115 27.8864 6.90257 27.6847 6.90257C27.4986 6.91808 27.3435 7.02666 27.2659 7.19729ZM26.8006 7.41445C26.8006 6.91808 27.1884 6.51479 27.7003 6.51479C28.2121 6.51479 28.5844 6.88706 28.5844 7.39894V7.56956H27.2504C27.3125 7.77121 27.4676 7.8953 27.7003 7.8953C27.8864 7.8953 28.0105 7.81774 28.1036 7.67814L28.4913 7.91081C28.3207 8.15899 28.0725 8.2986 27.7003 8.2986C27.1418 8.2986 26.8006 7.91081 26.8006 7.41445Z"
          fill="white"
        />
        <path
          d="M28.8481 6.54581H29.329V6.76297C29.4376 6.60785 29.6082 6.51479 29.8099 6.51479C30.1976 6.51479 30.4613 6.77848 30.4613 7.2128V8.26757H29.965V7.29036C29.965 7.05768 29.8564 6.93359 29.6547 6.93359C29.4686 6.93359 29.329 7.0732 29.329 7.32138V8.26757H28.8481V6.54581Z"
          fill="white"
        />
        <path
          d="M30.6475 6.54581H30.9577V6.25109L31.423 5.9874V6.56132H31.8573V6.98013H31.423V7.6316C31.423 7.81774 31.5006 7.86427 31.5937 7.86427C31.6557 7.86427 31.7022 7.84876 31.7488 7.80223L31.9659 8.1745C31.8418 8.26757 31.7022 8.3141 31.5316 8.3141C31.1593 8.3141 30.9577 8.14348 30.9577 7.66263V6.99564H30.6475V6.54581Z"
          fill="white"
        />
        <path
          d="M32.4778 7.19729H33.3154C33.2534 7.01115 33.0982 6.90257 32.8966 6.90257C32.7105 6.91808 32.5553 7.02666 32.4778 7.19729ZM32.0125 7.41445C32.0125 6.91808 32.4002 6.51479 32.9121 6.51479C33.424 6.51479 33.7963 6.88706 33.7963 7.39894V7.56956H32.4623C32.5243 7.77121 32.6794 7.8953 32.9121 7.8953C33.0982 7.8953 33.2223 7.81774 33.3154 7.67814L33.7032 7.91081C33.5326 8.15899 33.2844 8.2986 32.9121 8.2986C32.3692 8.2986 32.0125 7.91081 32.0125 7.41445Z"
          fill="white"
        />
        <path
          d="M34.0599 6.54581H34.5408V6.76297C34.6494 6.60785 34.82 6.51479 35.0216 6.51479C35.4094 6.51479 35.6731 6.77848 35.6731 7.2128V8.26757H35.1768V7.29036C35.1768 7.05768 35.0682 6.93359 34.8665 6.93359C34.6804 6.93359 34.5408 7.0732 34.5408 7.32138V8.26757H34.0599V6.54581Z"
          fill="white"
        />
        <path
          d="M15.074 8.26757C14.4535 8.26757 13.9572 7.7712 13.9572 7.15075C13.9572 6.53029 14.5001 6.04944 15.0585 6.04944C15.3687 6.04944 15.6324 6.15802 15.834 6.35967L15.4773 6.71643C15.3532 6.59234 15.2136 6.5458 15.074 6.5458C14.7172 6.5458 14.4845 6.82501 14.4845 7.15075C14.4845 7.50751 14.7327 7.7712 15.074 7.7712C15.3066 7.7712 15.5238 7.6316 15.6014 7.39893H16.1287C16.0357 7.91081 15.5703 8.26757 15.074 8.26757Z"
          fill="white"
        />
        <path
          d="M24.8151 30.2162C24.6911 30.2162 24.5515 30.1697 24.4584 30.0766L20.9683 26.6486C20.7512 26.4314 20.6891 26.1212 20.7977 25.8575C20.9063 25.5783 21.17 25.4077 21.4647 25.4077H28.1501C28.4448 25.4077 28.7085 25.5783 28.8171 25.8575C28.9257 26.1367 28.8636 26.4469 28.6465 26.6486L25.1564 30.0766C25.0788 30.1697 24.9547 30.2162 24.8151 30.2162Z"
          fill="#004DF5"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_3882">
          <rect
            width="49.1091"
            height="64"
            fill="white"
            transform="translate(0.26062)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
);
